<div class="containerTicket" (mouseleave)="isShowUserPanelFunc('leave')">
  <div class="cta">
    <img
      src="{{
        ticket.TICKETURL == null
          ? '../../../../assets/placeholder-image.jpeg'
          : ticket.TICKETURL
      }}"
      alt=""
    />
    <div class="text">
      <h2>{{ ticket.TICKETNAME }}</h2>
      <p>
        {{ ticket.TICKETDETAIL }}
      </p>
      <div class="user-main" *ngIf="isShowUserPanel">
        <form [formGroup]="ticketForm">
          <div class="row">
            <div class="date col-md-12">
              <div class="row" style="align-items: center">
                <div class="col-6">
                  <label for="checkDate">Tarih</label>
                </div>
                <div class="col-6 date-div">
                  <input
                    (change)="changeDate()"
                    id="checkDate"
                    type="date"
                    formControlName="checkDate"
                  />
                </div>
              </div>
            </div>
            <span class="user-body" *ngIf="!isLoadNewTicket">
              <div class="adult-main col-md-12">
                <div class="row">
                  <div class="adult-title col-4">
                    {{ "Adult" | translate | async }}
                  </div>
                  <div class="adult-price col-4">
                    <span style="width: 50%">{{
                      ticket.SUBTICKETS.ADULT.PRICE
                    }}</span
                    >{{ ticket.SUBTICKETS.CHILDREN.CURRENCY }}
                  </div>
                  <div class="adult-count col-4">
                    <div class="count-panel row">
                      <div
                        class="count-decrement col-4"
                        (click)="decrementCount('adultCount')"
                      >
                        -
                      </div>
                      <div class="count col-4">
                        <input type="text" formControlName="adultCount" />
                      </div>
                      <div
                        class="count-increment col-4"
                        (click)="incrementCount('adultCount')"
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="children-main col-md-12">
                <div class="row">
                  <div class="children-title col-4">
                    {{ "Children" | translate | async }}
                  </div>
                  <div class="children-price col-4">
                    <span style="width: 50%">{{
                      ticket.SUBTICKETS.CHILDREN.PRICE
                    }}</span
                    >{{ ticket.SUBTICKETS.CHILDREN.CURRENCY }}
                  </div>
                  <div class="children-count col-4">
                    <div class="count-panel row">
                      <div
                        class="count-decrement col-4"
                        (click)="decrementCount('childrenCount')"
                      >
                        -
                      </div>
                      <div class="count col-4">
                        <input type="text" formControlName="childrenCount" />
                      </div>
                      <div
                        class="count-increment col-4"
                        (click)="incrementCount('childrenCount')"
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="button-footer col-md-12">
                <div class="button-div">
                  <button
                    class="button-close"
                    role="button"
                    (click)="isShowUserPanelFunc()"
                  >
                    Kapat
                  </button>
                  <button
                    class="button-user"
                    role="button"
                    (click)="addTicket()"
                  >
                    Sepete Ekle
                  </button>
                </div>
              </div>
            </span>
            <span
              *ngIf="isLoadNewTicket"
              class="user-body"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <div
                *ngIf="isShowNewTicketError"
                style="color: red; font-size: 10px"
              >
                Seçtiğiniz tarihe uygun bilet bulunamadı.Lütfen başka tarihe
                bakınız.
              </div>

              <img
                src="../../../../assets/tail-spin.svg"
                style="height: 100%"
                alt=""
              />
            </span>
          </div>
        </form>
      </div>
      <div class="button-div-footer">
        <button (click)="isShowUserPanelFunc()">
          {{ !isShowUserPanel ? "Bilet Al" : "Paneli Kapat" }}
        </button>
      </div>
    </div>
  </div>
</div>
